import Handler from "../Handler";

export default class TableStatisticsHandler extends Handler{
    execute(message){
        let receivedData = JSON.parse(message);
        this.service.processTableStats(receivedData);
    }
}